import React from 'react';
import './warning-container.css';

const WarningContainer = ({ children }) => (
  <div className='container'>
    <div className='panel panel-danger panel-leyenda'>
      <div className='panel-body'>
        <div className='text-center'>
          <span>{ children }</span>
        </div>
      </div>
    </div>
  </div>
);

export default WarningContainer;
